// Open-redirect guard for stashed deep-link return paths (the previsit_return_to key + Auth0
// appState.returnTo). Only honor a SAME-ORIGIN RELATIVE path that starts with EXACTLY one '/'.
// Reject protocol-relative forms ('//host', '/\host') — window.location.href / loginWithRedirect
// would otherwise follow them OFF-ORIGIN, a phishing pivot off the trusted HIPAA domain. A crafted
// link like https://app.rcmtask.com//evil.com yields window.location.pathname === '//evil.com'.
export function isSafeReturnPath(p: unknown): p is string {
  return typeof p === 'string' && p.startsWith('/') && !p.startsWith('//') && !p.startsWith('/\\');
}

export function safeReturnPath(p: unknown, fallback = '/dashboard'): string {
  return isSafeReturnPath(p) ? p : fallback;
}
